import React, { useContext } from "react"
import Layout from "../components/layout"
import Seo from "../components/Seo"
import { I18nextContext } from "gatsby-plugin-react-i18next"
import { graphql } from "gatsby"
import PortableText from "../components/PortableText"
import { GatsbyImage } from "gatsby-plugin-image"
import ContactForm from "../components/ContactForm"
import {
  BiHomeAlt,
  BiHome,
  BiWinkSmile,
  BiMobileVibration,
  BiEnvelopeOpen,
} from "react-icons/bi"

const ContactsPage = ({ data }) => {
  const { language } = useContext(I18nextContext)
  const { blockOne, title, author } = data.sanityContacts

  return (
    <Layout>
      <Seo lang={language} title={title[language]} />
      <div className="max-w-screen-xl mx-auto">
        <div className="grid3">
          <div className="col-span-3 sm:col-span-2">
            <h1>{blockOne.header[language]}</h1>
            <hr />
            <section className="styledline">
              <PortableText textData={blockOne._rawBody[language]} />
            </section>
            <ContactForm />
          </div>
          <div className="col-span-3 sm:col-span-1">
            <figure>
              <GatsbyImage
                image={
                  blockOne.thumbnail.asset?.localFile.childImageSharp
                    .gatsbyImageData
                }
                className="rounded"
                alt={blockOne.thumbnail.attribution || "Minä voin"}
              />
              {blockOne.thumbnail.caption !== null && (
                <figcaption className="text-gray-900 pt-2">
                  {blockOne.thumbnail.caption[language]}
                </figcaption>
              )}
            </figure>
            <h3 className="pt-5">
              {author.contactInformationHeader[language]}
            </h3>
            <section>
              <p className="text-red-600">{author.introText[language]}</p>
              <section className="py-3">
                <div className="pb-5 flex flex-wrap">
                  <BiWinkSmile className="react-icons" />
                  <span className="pl-3 font-body font-semibold">
                    {author.name}
                  </span>
                </div>
                <div className="pb-5 flex flex-wrap">
                  <BiHome className="react-icons" />
                  <span className="pl-3 font-body font-semibold">
                    {author.cityOne}
                  </span>
                </div>
                <div className="pb-5 flex flex-wrap">
                  <BiHomeAlt className="react-icons" />
                  <span className="pl-3 font-body font-semibold">
                    {author.cityTwo}
                  </span>
                </div>
                <div className="pb-5 flex flex-wrap">
                  <BiMobileVibration className="react-icons" />
                  <a
                    href={`tel:${author.phoneNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="no-underline pl-3 font-body font-semibold"
                  >
                    {author.phoneNumber}
                  </a>
                </div>
                <div className="pb-5 flex flex-wrap">
                  <BiEnvelopeOpen className="react-icons" />
                  <a
                    href={`mailto:${author.emailAddress}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="no-underline pl-3 font-body font-semibold"
                  >
                    {author.emailAddress}
                  </a>
                </div>
              </section>
              <section>
                <p className="py-3">{author.finalText[language]}</p>
              </section>
            </section>
          </div>
        </div>
      </div>
    </Layout>
  )
}
export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
    sanityContacts {
      title {
        en
        fi
      }
      blockOne {
        header {
          en
          fi
        }
        thumbnail {
          asset {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          attribution
          caption {
            en
            fi
          }
        }
        _rawBody(resolveReferences: { maxDepth: 10 })
      }
      author {
        contactInformationHeader {
          en
          fi
        }
        introText {
          en
          fi
        }
        cityOne
        cityTwo
        phoneNumber
        name
        emailAddress
        finalText {
          en
          fi
        }
      }
    }
  }
`
export default ContactsPage
